import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { AmbulanceTrackingComponent } from './ambulance-tracking/ambulance-tracking.component';
import { LoginGuard } from './login.guard';
import { ArticlesComponent } from './articles/articles.component';
import { UserOrdersComponent } from './user-orders/user-orders.component';
import { BlogDetailComponent } from './blog-detail/blog-detail.component';
import { EditProfileComponent } from './edit-profile/edit-profile.component';
import { ChatComponent } from './chat/chat.component';
import { PatientComponent } from './patient/patient.component';
import { RazorpayComponent } from './razorpay/razorpay.component';
import { LinksComponent } from './links/links.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { Atricles2Component } from './atricles2/atricles2.component';
import { BlogDetail2Component } from './blog-detail2/blog-detail2.component';
import { ShareTrackingComponent } from './share-tracking/share-tracking.component';
import { ChatBotComponent } from './chat-bot/chat-bot.component';
import { UserPlansComponent } from './user-plans/user-plans.component';
import { UserWalletComponent } from './user-wallet/user-wallet.component';
import { UserNotificationsComponent } from './user-notifications/user-notifications.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    data: { title: 'Home' }
  },
  {
    path: 'Doctor',
    loadChildren: () => import('./partner/doctor/doctor.module').then(m => m.DoctorModule)
  },
  {
    path: 'Hospital',
    loadChildren: () => import('./partner/hospital/hospital.module').then(m => m.HospitalModule)
  },
  {
    path: 'Labs',
    loadChildren: () => import('./partner/lab/lab.module').then(m => m.LabModule)
  },
  {
    path: 'Pharmecy',
    loadChildren: () => import('./partner/pharmacy/pharmacy.module').then(m => m.PharmacyModule)
  },
  {
    path: 'Blood_bank',
    loadChildren: () => import('./partner/pharmacy/pharmacy.module').then(m => m.PharmacyModule)
  },
  { path: 'user-profile', component: UserProfileComponent, canActivate: [LoginGuard] },
  { path: 'notifications', component: UserNotificationsComponent, canActivate: [LoginGuard] },
  { path: 'edit-profile', component: EditProfileComponent, canActivate: [LoginGuard] },
  { path: 'ambulance-tracking', component: AmbulanceTrackingComponent, canActivate: [LoginGuard] },
  { path: 'track/:userId', component: ShareTrackingComponent },
  { path: 'user-orders', component: UserOrdersComponent, canActivate: [LoginGuard] },
  { path: 'user-plans', component: UserPlansComponent, canActivate: [LoginGuard] },
  { path: 'user-wallet', component: UserWalletComponent, canActivate: [LoginGuard] },
  { path: 'articles123/:type', component: ArticlesComponent },
  { path: 'blog-detail/:id', component: BlogDetail2Component },
  { path: 'blog-detail256/:id', component: BlogDetail2Component },
  { path: 'chat/:id', component: ChatComponent, canActivate: [LoginGuard] },
  { path: 'medical-history', component: PatientComponent, canActivate: [LoginGuard] },
  { path: 'razorpay', component: RazorpayComponent },
  { path: 'page/:type', component: LinksComponent },
  { path: 'privacy', component: PrivacyComponent },
  { path: 'articles', component: Atricles2Component },
  { path: 'telemedicine', component: ChatBotComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
